// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__KXI7X","col":"styles_col__7hp1m","fulfillmentStatus":"styles_fulfillmentStatus__1oG2b","emailCol":"styles_emailCol__1pOU9"};